import * as React from "react";
const SvgGuru = props => /*#__PURE__*/React.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24",
  ...props
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Guru_svg__a)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "#F7F7F7",
  rx: 6
}), /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M22.014 13.887c.07 2.495-1.01 4.36-3.138 5.555-2.945 1.663-6.117 2.66-9.543 2.557-1.93-.062-3.475-.987-4.487-2.604C2.908 16.298 1.864 12.908 1.99 9.24c.067-1.93 1.063-3.442 2.69-4.437 3.062-1.874 6.398-2.913 10.016-2.792 1.96.065 3.472 1.08 4.501 2.722 1.752 2.795 2.57 5.892 2.817 9.155"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M13.38 15.773a3.9 3.9 0 0 1-2.33.134c-1.817-.494-3.135-2.158-3.135-3.97a4.02 4.02 0 0 1 1.195-2.93 4.07 4.07 0 0 1 2.797-1.182h.038c1.916.021 3.131 1.468 3.141 1.482a.477.477 0 1 0 .74-.601c-.06-.074-1.497-1.808-3.87-1.834a5.01 5.01 0 0 0-4.994 5.062c0 2.236 1.614 4.294 3.84 4.891.383.102.777.152 1.173.15a5 5 0 0 0 1.729-.31c1.466-.535 2.897-1.945 2.845-3.58q-.502.362-1.045.658c-.283.903-1.178 1.686-2.124 2.03"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.98 10.808a7.6 7.6 0 0 1-1.03.89c-.638-.617-1.653-.916-2.387-.916-.6 0-1.06.158-1.367.468a1.26 1.26 0 0 0-.36.925c.01.648.476 1.349 1.749 1.377.71.018 1.404-.212 2.011-.523q.452-.231.864-.527a8.3 8.3 0 0 0 1.219-1.046.477.477 0 1 0-.7-.648zM13.606 12.6c-.37-.008-.81-.091-.816-.44a.32.32 0 0 1 .085-.246c.068-.07.247-.184.688-.184a2.85 2.85 0 0 1 1.522.494 3.2 3.2 0 0 1-1.479.376"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Guru_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
}))));
export default SvgGuru;
//# sourceMappingURL=Guru.js.map